import type { ChecklistItemAnswerInDto } from 'shared/dtos/in/template';
import {
  HttpRequestEntity,
  HttpRequestModelType,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistAnswerHttpDeleteRequestModel } from '../checklistAnswer/types';
import {
  broadcastChecklistAnswerOperationError,
  broadcastCreatedChecklistAnswer,
  broadcastUpdatedChecklistAnswer,
  broadcastDeletedChecklistAnswer,
} from 'serviceWorker/broadcasts/checklistAnswers';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { inspectionTemplateSource } from 'serviceWorker/services/inspectionTemplates/inspectionTemplateSource';
import { responseErrorOf } from './responseError';

function isChecklistAnswerDeleteRequest(
  request: HttpRequestEntity
): request is HttpRequestEntity & ChecklistAnswerHttpDeleteRequestModel {
  return (
    request.entityType === HttpRequestModelType.checklistAnswer &&
    request.method === 'DELETE'
  );
}

export function broadcastChecklistAnswerResponse(
  request: HttpRequestEntity,
  response: unknown
): void {
  const error = responseErrorOf(response);
  if (error) {
    return broadcastChecklistAnswerOperationError(error, request.data?.uniqueId, chooseErrorMessage(error));
  }
  // Sections, items and answers are stored inside their template: sync it.
  inspectionTemplateSource.sync();
  // The server's answer once it carries no error.
  const answer = response as ChecklistItemAnswerInDto;

  if (request.method === 'POST') {
    return broadcastCreatedChecklistAnswer(answer, request.data.uniqueId);
  }

  if (request.method === 'PUT') {
    return broadcastUpdatedChecklistAnswer(answer, request.data.uniqueId);
  }

  if (isChecklistAnswerDeleteRequest(request)) {
    const { answerId, uniqueId } = request.data;

    return broadcastDeletedChecklistAnswer({ _id: answerId }, uniqueId);
  }
}
